{
  "EMOJI": {
    "PLACEHOLDER": "Αναζήτηση emojis",
    "NOT_FOUND": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας",
    "REMOVE": "Διαγραφή"
  }
}
